/* eslint-disable no-unused-vars */

import apiClient from '@u/apiClient'
import InstantSearchController from '@/wayfinder/actions/App/Http/Controllers/InstantSearch/InstantSearchController'
import InstantSearchPreviewController from '@/wayfinder/actions/App/Http/Controllers/InstantSearch/InstantSearchPreviewController'

export default {
  getInstantSearchResult({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(InstantSearchController.get(), {
          signal: payload.signal,
          params: {
            terms: payload.terms,
            latitude: payload.latitude,
            longitude: payload.longitude,
            search: payload.search
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getInstantSearchDetail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(InstantSearchPreviewController.get(), {
          signal: payload.signal,
          params: {
            type: payload.type,
            id: payload.id
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
